
import NodeTreeWidget from './NodeTreeWidget'
import NodeRecordWidget from './NodeRecordWidget'
import LogTableWidget from './LogTableWidget'
import FrontMenu from './FrontMenu'
import UserName from './UserName'
import UserMenu from './UserMenu'
import ServiceTime from './ServiceTime'
import Profile from './Profile'
import ChangePassword from './ChangePassword'
import NodeCardSetting from './NodeCardSetting'
import LogOut from './LogOut'
import AppPage from './AppPage'
import DepartmentTree from './DepartmentTree'
import DepartmentSelect from './DepartmentSelect'
import NodeSelect from './NodeSelect'
import ModelSelect from './ModelSelect'
import NodeNavButton from './NodeNavButton'
import ScaleButton from './ScaleButton'
import ModelNodeSelect from './ModelNodeSelect'
import PointTable from './PointTable'
import DepartmentSelectNode from './DepartmentSelectZh'
import NavTabs from './NavTabs'

import { C } from 'xadmin-ui'

const ViewSelect = C.lazy('ViewSelect')

export default {
  dashboard_widgets: {
    /* 前台组态组件 */
    FrontMenu,         // 菜单
    UserMenu,          // 用户信息
    UserName,          // 用户名称
    Profile,           // 个人设置-限制只能修改基本信息
    ChangePassword,    // 修改密码 
    ServiceTime,       // 系统时间
    LogOut,            // 退出系统
    AppPage,           // 子页面
    /* ========== */
    NodeCardSetting,
    NodeTreeWidget,
    NodeRecordWidget,
    LogTableWidget,
    DepartmentTree,
    DepartmentSelect,
    NodeSelect,
    ModelSelect,
    ModelNodeSelect,
    NodeNavButton,
    ScaleButton,
    PointTable,
    DepartmentSelectNode,
    NavTabs
  },
  'settings.schema': app => (props, cb) => {
    cb(null, {
      name: 'customPage',
      title: '前台页面',
      parentTab: '前台配置',
      type: 'object',
      properties: {
        home: {
          type: 'object',
          title: '母版画面',
          description: '定义母版后，前台系统所有页面均应用母版定义的内容',
          properties: {}
        },
        dashboard: {
          type: 'object',
          title: '首页画面',
          description: '通过选择画面，定义前台的默认首页',
          properties: {}
        },
        // mobileHome: {
        //   type: 'object',
        //   title: '移动端母版画面',
        //   properties: {}
        // },
        // mobileDashboard: {
        //   type: 'object',
        //   title: '移动端首页画面',
        //   properties: {}
        // },

        headerBackgrounColor: {
          type: 'string',
          title: '导航栏颜色',
          fieldType: 'color'
        },
        rectption_login_page: {
          title: '登录页',
          type: 'object',
          properties: {},
          description: '设置登录页画面，平台初始登录页会被替换，请谨慎操作',
          divider: 'advanced'
        },
        rectption_logout_page: {
          title: '退出页',
          type: 'object',
          properties: {},
          description: '设置退出登录页画面，平台初始退出登录页会被替换，请谨慎操作',
          divider: 'advanced'
        },
        rectption_login_next_page: {
          title: '登录后页面',
          type: 'object',
          properties: {},
          description: '设置登录后页面，登录成功将会跳转至此页面，页面显示设定时长后自动跳转至平台首页',
          divider: 'advanced'
        },
        rectption_login_next_page_hangtime: {
          title: '显示时长',
          type: 'number',
          fieldType: 'inputNumber',
          unit: '秒',
          formWidth: 200,
          minimum: 1,
          defaultVal: 5,
          description: '登录后页面显示时长，单位秒',
          divider: 'advanced',
          field: {
            effect: (f, form) => {
              if (_.isNil(f.value)) {
                form.change('rectption_login_next_page_hangtime', 5)
              }
            }
          }
        },
      },
      form: [
        'headerBackgrounColor',
        { key: 'home', component: props => <C is="ViewSelect" {...props} type="motherboadr" /> },
        { key: 'dashboard', component: (props) => <ViewSelect {...props} type='dashboard' /> },
        // { key: 'mobileHome', component: ViewSelect },
        // { key: 'mobileDashboard', component: ViewSelect },
        '*',
        { key: 'rectption_login_page', component: ViewSelect },
        { key: 'rectption_logout_page', component: ViewSelect },
        { key: 'rectption_login_next_page', component: ViewSelect },
        'rectption_login_next_page_hangtime',
      ],
      formEffect: form => {
        form.useField('rectption_login_next_page', ({ value }) => {
          form.setFieldData('rectption_login_next_page_hangtime', { display: !!value })
        })
      },
    })
  }
}
